import React from 'react';

const faqs = [
  {
    question: "What is PLUS and what is a PLUS Card?",
    answer: (
      <div>
        <b>PLUS lets you add, track and cash out your in-shop bets online. </b>
        With PLUS, you can manage your in-shop bets online, link your William Hill online account to get free bets & exclusive offers. While PLUS card is a free, contactless card that makes it easy to track your in-shop bets. PLUS card can be used to:
        <ul>
          <li>Add and track bets placed in-shop on the PLUS Web App</li>
          <li>Place bets in-shop using your online balance</li>
          <li>Withdraw online funds as cash in-shop</li>
        </ul>
      </div>
    )
  },
  {
    question: "How do I get a PLUS card?",
    answer: (
      <div>
        You can pick up a PLUS card in any one of our 1400+ shops. It is free, quick and easy. 
        <b>Get started with PLUS in 3 easy steps:</b>
        <ul>
          <li>Get your PLUS card from the shop counter</li>
          <li>Tap your card on the self-service betting terminal contactless and register</li>
          <li>We will text you a welcome text message with a link - use it to track and cash out your in-shop bets</li>
        </ul>
      </div>
    )
  },
  {
    question: "What is the PLUS Web App?",
    answer: (
      <div>
        The PLUS Web App lets you follow the progress of your bets on your mobile device, tablet or computer. From the website you can:
        <ul>
          <li>View your active and recently settled bets</li>
          <li>View the live scoreboard and stats for events that are currently in play</li>
          <li>'Cash out' your bet for a guaranteed payout whether the bet ends up as a winner or loser</li>
        </ul>
      </div>
    )
  },
  {
    question: "What should I do if my card gets lost or stolen?",
    answer: (
      <div>
        Your card doesn't store your bet details or personal details, so your bets and privacy are <b>not at risk</b>. Simply cancel the old card using the 'Account' menu option in the PLUS Web App and register a new one on a William Hill self-service betting terminal.
        <br /><br />After your card has been cancelled it will not work on any terminal, and cannot be reactivated, so if you find it again you should dispose of it responsibly.
      </div>
    )
  },
  {
    question: "How do I track a bet?",
    answer: (
      <div>
        You can track bets placed on a William Hill self-service betting terminal at any time from any device without a William Hill online account, using any of these methods:
        <ul>
          <li>Tapping your PLUS card when you place your bet, or by typing the 18-character slip number into the PLUS Web App</li>
          <li>Scanning the bet slip barcode on any William Hill self-service betting terminal and tapping your card against the contactless card reader</li>
          <li>Login to PLUS Web App account and manually entering the slip number by pressing 'Add Bets'</li>
        </ul>
      </div>
    )
  },
  {
    question: "How do I cash out a bet?",
    answer: (
      <div>
        The option to cash out your bet is only available on the PLUS Web App, NOT on the William Hill self-service betting terminals. To cash out follow these steps:
        <ul>
          <li>Login to the PLUS Web App</li>
          <li>Choose the open bet you want to cash out</li>
          <li>Press the blue 'Cash out' button at the bottom of the screen</li>
        </ul>
        <br />
        You can collect your winnings from ANY William Hill shop (the online shop locator on the website will show where the nearest one is) or withdraw to your online account.
      </div>
    )
  },
  {
    question: "Benefits of linking my PLUS card with my online account?",
    answer: (
      <div>
        <ul>
          <li>Bet in-shop with online funds</li>
          <li>Withdraw or deposit online funds in cash from our shops</li>
        </ul>
      </div>
    )
  },
  {
    question: "How do I link my online accounts to my PLUS card",
    answer: (
      <div>
        <ul>
          <li>Log in to the PLUS Web App and click 'Register' from the menu in the top left corner</li>
          <li>Click 'Link accounts now' or 'Sign up now' if you don't have an online account</li>
          <li>Enter your username and password</li>
        </ul>
      </div>
    )
  },
  {
    question: "Why do I need to set up a PIN?",
    answer: (
      <div>
        A PIN is used when you make a withdrawal request, transfer winnings to your online account or place a bet using your online funds so we know it's you. You'll need to remember it and keep it secure, but if you forget it, you can set a new one by logging into your online account, going to the 'Account' menu and selecting PLUS. There's an option to change your PIN.
      </div>
    )
  },
  {
    question: "Can I place a bet in-shop using my online balance?",
    answer: (
      <div>
        Yes. Just select your bets on our PLUS terminal (but don't load any cash onto it), press the 'Place bet' button, scan your PLUS card on the terminal's contactless, enter your 4-digit PIN. The bet will be placed using your online funds. Also note that, any winnings from a bet placed using online funds will immediately go back into your online account balance.
      </div>
    )
  },
];

export default faqs;
